/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import TextFormatter from 'utils/TextFormatter';
import RaisedButton from 'material-ui/RaisedButton';
//import EquipmentUtils from 'utils/EquipmentUtils';

class SqcLevelsButton extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.generateSqc = this
            .generateSqc
            .bind(this);
    }

    generateSqc(e) {
        e.preventDefault();
        const {sqcActions, outlet, orderId} = this.props;

        const macAddress = TextFormatter.formatMacAddress(outlet.get('macAddress'));

        const request = {
            'macaddress': macAddress
        };

        if (macAddress) {
            sqcActions.sqcGenerateLoadStarted(request, orderId);
        }
    }

    render() {
        const {outlet, showMacAddessOnButton} = this.props;

        let macDispaly = null;
        if (showMacAddessOnButton) {
            macDispaly = (
                <span>
                    <hr/>
                    <label>Mac Address: &nbsp;
                    </label>{TextFormatter.formatMacAddress(outlet.get('macAddress'))}<br/></span>
            );
        }

        //if (EquipmentUtils && EquipmentUtils.isHsdEquipment(outlet) && outlet.get('sqcCheckFlag')) {
        if (outlet.get('sqcCheckFlag')) {
            return (
                <div>
                    {macDispaly}
                    <RaisedButton primary onTouchTap={this.generateSqc} label="Get Levels"/>
                </div>
            );
        }

        return null;

    }
}

SqcLevelsButton.propTypes = {
    outlet: PropTypes.object,
    orderId: PropTypes.string,
    sqcActions: PropTypes.object,
    showMacAddessOnButton: PropTypes.bool

};
export default SqcLevelsButton;



// WEBPACK FOOTER //
// ./src/components/equipment/SqcLevelsButton.js